// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoBg {
  height: 10vh;
  width: 60%;
  margin: 0 auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  z-index: 10000;
  margin-bottom: 5%;
}
.login {
  padding: 25px;
  margin: 0 auto;
  width: 60%;
  border-radius: 5px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 5%;
  position: relative;
  background: white;
}

.mobileLogin {
  padding: 25px;
  margin: 'inherit';
  width: 60%;
  border-radius: 5px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 5%;
  position: relative;
  background: white;
}

.login.resetPassword {
  height: 55vh;
}
.login.resetPassword:after {
  bottom: 96%;
}

.forgotPasswordLink {
  width: -moz-fit-content !important;
  width: fit-content !important;
  color: rgb(230, 97, 106);
}

.resendCodeLink {
  width: -moz-fit-content !important;
  width: fit-content !important;
  color: #252525;
}

.extraLinks {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/containers/main.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;EACE,kCAA6B;EAA7B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,kCAA6B;EAA7B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".logoBg {\n  height: 10vh;\n  width: 60%;\n  margin: 0 auto;\n  background-image: url('../assets/img/logo.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  position: relative;\n  z-index: 10000;\n  margin-bottom: 5%;\n}\n.login {\n  padding: 25px;\n  margin: 0 auto;\n  width: 60%;\n  border-radius: 5px;\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.03);\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  margin-top: 5%;\n  position: relative;\n  background: white;\n}\n\n.mobileLogin {\n  padding: 25px;\n  margin: 'inherit';\n  width: 60%;\n  border-radius: 5px;\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.03);\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  margin-top: 5%;\n  position: relative;\n  background: white;\n}\n\n.login.resetPassword {\n  height: 55vh;\n}\n.login.resetPassword:after {\n  bottom: 96%;\n}\n\n.forgotPasswordLink {\n  width: fit-content !important;\n  color: rgb(230, 97, 106);\n}\n\n.resendCodeLink {\n  width: fit-content !important;\n  color: #252525;\n}\n\n.extraLinks {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
